module.exports = __webpack_public_path__ + "img/idcard2.85426326.png";